import NewPassword from "./dialogs/NewPassword";
import ChangePassword from "./dialogs/ChangePassword";
import LogoutDlg from "./dialogs/LogoutDlg";
import LockIcon from "../gui/Icons/LockIcon";
import { useOverlay } from "../gui/Overlay/OverlayProvider";
import IconButton from "../gui/Button/IconButton";
import AddIcon from "../gui/Icons/AddIcon";
import PasswordIcon from "./icons/PasswordIcon";
import LogoutIcon from "../gui/Icons/LogoutIcon";
import Form from "../gui/Form/Form";
export default function(){
    const {addOverlay} = useOverlay()
    const onAdd = () => addOverlay("passwordDlg", {children:<Form><NewPassword/></Form>, className:"dialog"})
    const onPass = () => addOverlay("passwordDlg", {children:<Form><ChangePassword/></Form>, className:"dialog"})
    const onLogout = () => addOverlay("passwordDlg", {children:<Form><LogoutDlg/></Form>, className:"dialog"})
    return <header>
        <div className="flex middle between content">
            <div className="flex middle gap-8">
                <LockIcon/>
                <b>PASSWORDS</b>
            </div>
            <div className="flex middle gap-8">
                <IconButton onClick={onAdd}><AddIcon/></IconButton>
                <IconButton onClick={onPass}><PasswordIcon/></IconButton>
                <IconButton onClick={onLogout}><LogoutIcon/></IconButton>
            </div>
        </div>
    </header>
}